/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantVcdsDeploymentApplicationHealth } from './tenantVcdsDeploymentApplicationHealth';
import { VcdsDeploymentCloudProvider } from './vcdsDeploymentCloudProvider';
import { DetailedVcdsDeploymentInventoryTree } from './detailedVcdsDeploymentInventoryTree';
import { KeyValuePair } from './keyValuePair';
import { VcdsDeploymentSystemIssue } from './vcdsDeploymentSystemIssue';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsDeploymentStateEnum } from './vcdsDeploymentStateEnum';
import { VcdsDeploymentNetwork } from './vcdsDeploymentNetwork';
import { VcdsDeploymentStats } from './vcdsDeploymentStats';
import { DetailedVcdsDeploymentCommerce } from './detailedVcdsDeploymentCommerce';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';
import { VcdsDeploymentVersion } from './vcdsDeploymentVersion';


export interface TenantDetailedVcdsDeployment { 
    /**
     * Org Id
     */
    org_id?: string;
    /**
     * Deployment Id
     */
    deployment_id?: string;
    service_type?: ServiceTypeEnum;
    vcds_service_type?: VcdsServiceTypeEnum;
    state?: VcdsDeploymentStateEnum;
    /**
     * Deployment name
     */
    name?: string;
    /**
     * Deployment secondary name
     */
    secondary_name?: string;
    vmware_managed?: boolean;
    discovered?: boolean;
    login_allowed?: boolean;
    cloud_provider?: VcdsDeploymentCloudProvider;
    network?: VcdsDeploymentNetwork;
    version?: VcdsDeploymentVersion;
    /**
     * Initial deployment spec
     */
    spec?: { [key: string]: any; };
    commerce?: DetailedVcdsDeploymentCommerce;
    inventory?: DetailedVcdsDeploymentInventoryTree;
    metadata?: Array<KeyValuePair>;
    /**
     * Created by user
     */
    created_by?: string;
    /**
     * Deployment creation date time
     */
    created_time?: Date;
    /**
     * Deleted by user
     */
    deleted_by?: string;
    /**
     * Deployment deletion date time
     */
    deleted_time?: Date;
    /**
     * Last reported date time of inventory, usage or health from agent
     */
    last_reported_time?: Date;
    /**
     * Deployment last updated date time
     */
    last_updated_time?: Date;
    stats?: VcdsDeploymentStats;
    system_issues?: Array<VcdsDeploymentSystemIssue>;
    tasks?: Array<string>;
    health?: TenantVcdsDeploymentApplicationHealth;
}
export namespace TenantDetailedVcdsDeployment {
}


